<route-container
  *ngIf="hasRouterOutlet"
  [uid]="uid"
  [debug]="debug"
>
  <ng-container [ngTemplateOutlet]="dynamicLoader"></ng-container>
</route-container>

<ng-container *ngIf=!hasRouterOutlet [ngTemplateOutlet]="dynamicLoader"></ng-container>

<ng-template #dynamicLoader>
  <loader-container
    [loader]="loader"
    [options]="{
      disableAutoRefresh: loaderOptions.disableAutoRefresh,
      context: loaderOptions.context,
      outerNgClass: loaderOptions.outerNgClass,
      errorTemplate: loaderOptions.errorTemplate,
      loadingTemplate: loaderOptions.loadingTemplate,
      contentTemplate: loaderOptions.contentTemplate || defaultContentTemplate
    }"
    (loaded)="onLoadComplete($event)"
  ></loader-container>
</ng-template>

<ng-template #defaultContentTemplate let-content=content let-reflectedType=reflectedType>
  <quick-preview-panel
    role="button"
    [routerLink]="routerLink"
    [color]="headingColor || (reflectedType !== 'array' || content.length > 0 ? 'primary' : 'warn')"
    [heading]="heading || 'Quick Card'"
    [headingIconKey]="headingIconKey"
  >
    <div class="d-flex align-items-center justify-content-center min-height-100">
      <div
        class="fw-light display-6 p-2 me-2 text-primary"
        [ngClass]="{ 'text-danger': content.length == 0 }"
      >
        <ng-container
          [ngTemplateOutlet]="innerContentTemplate || defaultInnerTemplate"
          [ngTemplateOutletContext]="{
            content: content,
            reflectedType: reflectedType
          }"
        >
        </ng-container>
      </div>
    </div>
  </quick-preview-panel>
</ng-template>

<ng-template #defaultInnerTemplate let-content=content let-reflectedType=reflectedType>
  <div *ngIf="reflectedType === 'array'">
    {{content.length}}
  </div>
  <div *ngIf="reflectedType !== 'array'">
    {{content | json}}
  </div>
</ng-template>
